<template>
  <div>
    <!-- 分享空白页面 -->
    <van-loading type="spinner" vertical color="#1989fa">加载中...</van-loading>
  </div>
</template>
<script>
import URL from '@/api/api'
import {setLocal, setSession, UrlSearch} from '@/utils/utils'

export default {
  data() {
    return {
      active: '全部',
      openid: '',
      userId: '',
      nickName: '',
      productList: [],
      value: this.$route.query.value,
      search: '',
      phoneNo: null,
      linkId: null
    };
  },
  mounted() {
    this.active = this.value
    this.openid = UrlSearch().openid
    this.userId = UrlSearch().userid
    this.nickName = UrlSearch().nickName
    if (!this.openid)
      this.openid = localStorage.getItem('openid') ? localStorage.getItem('openid') : localStorage.getItem('openIdC')
    if (!this.userId)
      this.userId = localStorage.getItem('userid') ? localStorage.getItem('userid') : localStorage.getItem('UserIdC')
    if (!this.nickName)
      this.nickName = localStorage.getItem('nickName') ? localStorage.getItem('nickName') : localStorage.getItem('nickNameC')
    this.linkId = UrlSearch().productid
    if (UrlSearch().productid) {
      setSession('product_id', UrlSearch().productid)
      setSession('agent_PhoneNo', UrlSearch().agentPhoneNo)
    }
    let temOpenId = localStorage.getItem("openidC") || localStorage.getItem("openid");
    if ((!this.openid || 'undefined' === this.openid) && (!temOpenId || 'undefined' === temOpenId)) {
      this.getCodeUrl()
    }
    if ((this.openid && 'undefined' !== this.openid)) {
      this.checkIsLoginAndAuth(this.openid)
      setLocal("UserIdC", this.userId);
      setLocal("openidC", this.openid);
    }
  },
  methods: {
    checkIsLoginAndAuth(openid) {
      this.$fetchPost(URL.getBindingInfo.url, this.$toFormData({'openid': openid ? openid : 'o59kX69cnk_4e7Ec704ijEzc1OX0'})).then(res => {
        if (res.data.code === 20000) {
          let phoneNo = res.data.data.phoneNo;
          this.phoneNo = phoneNo
          let authFlag = res.data.data.authFlag;
          let realName = res.data.data.realName;
          setLocal('phoneNoC', phoneNo);
          setLocal("authFlagC", authFlag);
          setLocal("realNameC", realName);
          let nickName = res.data.data.nickName;
          let headImg = res.data.data.headImg;
          setLocal("nickNameC", nickName);
          setLocal("headImgC", headImg);
          setLocal("cip", res.data.data.ip);
        }
        let linkId = sessionStorage.getItem('product_id')
        console.log(linkId);
        if (linkId) {
          this.getProduct()
        }
      })
    },
    getProduct() {
      this.getTraceSave()
      let linkId = sessionStorage.getItem('product_id')
      // let linkId=37
      this.$fetchGet(URL.productDetails.url, {id: linkId}).then(res => {
        if (res.data.code == 20000) {
          let flag = true;
          let url = res.data.data.externalLink;
          let postcode = res.data.data.postCode;
          let channel = res.data.data.companyCode;
          let caseCode = res.data.data.spuId;
          // let channel = 'ocft';
          if (linkId == 53 && sessionStorage.getItem('agent_PhoneNo')) {
            url = url + "&operCode=" + sessionStorage.getItem('agent_PhoneNo');
          } else if (url && url.indexOf("zhongbaounion.com") >= 0) {
            url = url + "&bizTag=" + sessionStorage.getItem('agent_PhoneNo') + "_" + localStorage.getItem('phoneNoC')
          } else if (postcode) {
            url = "https://dtfcloud.com/platform/#/" + "lufax?postcode=" + postcode + "&biztag=" + sessionStorage.getItem('agent_PhoneNo');
            //  this.$router.push({path:'/lufax',query:{postcode: postcode,biztag:sessionStorage.getItem('agent_PhoneNo')}})
          } else if (channel === 'ocft') {
            url = "https://dtfcloud.com/platform/#/" + "ocft?productCode=" + res.data.data.spuId + "&agentPhoneNo=" + sessionStorage.getItem('agent_PhoneNo');
            // this.$router.push({path:'/ocft',query:{productCode: res.data.data.spuId,agentPhoneNo:sessionStorage.getItem('agent_PhoneNo')}})
          } else if (channel === 'qixin') {//获取完产品后
            //齐欣保险
            flag = false;
            this.$fetchPost(URL.qixinProdUrl.url, this.$toFormData({
              'spuId': caseCode,
              'userId': localStorage.getItem("userid")
            })).then(resp => {
              if (resp.data.code === 20000) {
                window.location.href = resp.data.data
              }
            })
          }
          if (flag && url) {
            window.location.href = url;
          }

        } else if (res.data.code == 10000) {
          this.$router.replace('/delistedProducts')
        }


      })
    },
    getTraceSave() {
      let realName = localStorage.getItem('realNameC');
      let nickName = localStorage.getItem('nickNameC');
      let data = {
        agentPhoneNo: sessionStorage.getItem('agent_PhoneNo'),
        openid: localStorage.getItem('openidC'),
        phoneNo: this.phoneNo,
        headImg: localStorage.getItem('headImgC'),
        username: realName ? realName : nickName,
        userId: localStorage.getItem('userid'),
        productId: sessionStorage.getItem('product_id')
      }
      this.$fetchPost(URL.traceSave.url, data).then(res => {
      })
    }
  },
};
</script>
<style lang="less" scoped>
.van-loading {
  top: 100px;
}
</style>
